import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { getCurrentUserId, resetUserDataState, resetUserState, setCurrentUserId } from '../store/storeValtio';

export default function NavBar() {
  const navigate = useNavigate();
  const [refresh, setRefresh] = useState(false);
  const localCurrentUser = localStorage.getItem("currentUser");
  const currentUserId = getCurrentUserId();
  console.log("local currentUser: ", localCurrentUser, currentUserId);

  console.log('NavBar', currentUserId);

  function goRegister() {
    if (currentUserId)
    {
      console.log('logout');
      resetUserState();
      localStorage.clear();
      setCurrentUserId(null);
      resetUserDataState();
      navigate('/');
    } else {
      console.log('login');
      navigate('/login');
    }
    setRefresh(!refresh);
  }

  function goMeds() {
    navigate('/meds');
  }
  
  function goHome() {
    navigate('/home');
  }
  
  return (
    <div id='navbar' className='flex flex-row justify-between w-full bg-slate-700 py-4'>
        <div 
          className='flex items-center px-4 hover:cursor-pointer' 
          onClick={()=>goHome()}
          >
          <img className='w-14 h-14 ml-2 mr-8' src='/logo.png' alt='logo' />
          <span className='text-white font-bold text-2xl tablet:text-3xl'>I Took It When?</span>
        </div>
        <div className="flex itms-center pr-4">
          {currentUserId && (
            <button 
              className='p-2 mr-4 border-2 rounded-md bg-slate-500 text-white font-semibold text-xl float-right'
              onClick={()=>goMeds()}
            >
              Meds
            </button>
          )}
          <button
            className='p-2 border-2 rounded-md bg-slate-500 text-white font-semibold text-xl float-right'
            onClick={()=>goRegister()}
            >
            {currentUserId ? 'Logout' : 'Login'}
          </button>
        </div>
    </div>
  );
}

